import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import WhatToKnowItems from './what-to-know-items';
import { ItemContainer, PaymentSecurityInfoContainer, SubItemsContainer } from './subcomponents';
const PaymentSecurityInfo = () => {
    const { t } = useTranslation();
    return (_jsx(PaymentSecurityInfoContainer, { children: WhatToKnowItems.map(item => {
            const { subItems } = item;
            return (_jsxs(ItemContainer, { children: [t(`notEnrolled.whatToKnow.${item.value}`), subItems && (_jsx(SubItemsContainer, { children: subItems.map(subItem => (_jsx("li", { children: t(`notEnrolled.whatToKnow.${subItem.value}`) }, subItem.id))) }))] }, item.id));
        }) }));
};
export default PaymentSecurityInfo;
